export enum FeatureEntitlements {
  ScanAndPayRetailers = 'scan_and_pay_retailers',
}
